import { createContext, useContext, useMemo } from "react";
import { useLocalStorage } from "./useLocalStorage";
import axios from "axios";

const AuthContext = createContext();
const apiUrl = window.BACKOFFICE_API_URL;

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useLocalStorage("token", null);

  // call this function when you want to authenticate the user
  const login = (response) => {
    const accessToken = response.data.token;
    setToken(accessToken);
  };

  // call this function to sign out logged in user
  const logout = () => {
    setToken(null);
  };

  const publicAxios = () => {
    const instance = axios.create({
      baseURL: apiUrl,
    });

    return instance;
  };

  const authAxios = () => {
    const instance = axios.create({
      baseURL: apiUrl,
    });

    instance.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          setToken(null);
        }
        return error;
      },
    );

    instance.interceptors.request.use(
      (config) => {
        if (!config.headers.Authorization) {
          config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
      },
      (error) => {
        return Promise.reject(error);
      },
    );

    return instance;
  };

  const value = useMemo(
    () => ({
      token,
      setToken,
      login,
      logout,
      publicAxios,
      authAxios,
    }),
    [token],
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};

export const selectedApiUrl = () => {
  return apiUrl;
};
